import { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext(null);

const translations = {
  en: {
    home: 'Home', latest: 'Latest', trending: 'Trending', categories: 'Categories',
    politics: 'Politics', business: 'Business', sports: 'Sports', entertainment: 'Entertainment',
    technology: 'Technology', culture: 'Culture', localNews: 'Local News',
    breakingNews: 'Breaking News', readMore: 'Read More', relatedArticles: 'Related Articles',
    share: 'Share', comments: 'Comments', writeComment: 'Write a comment...',
    postComment: 'Post Comment', subscribe: 'Subscribe', newsletter: 'Newsletter',
    subscribePlaceholder: 'Enter your email', subscribeBtn: 'Subscribe Now',
    search: 'Search', searchPlaceholder: 'Search news...',
    login: 'Login', logout: 'Logout', admin: 'Admin Panel', editor: 'Editor Panel',
    dashboard: 'Dashboard', articles: 'Articles', users: 'Users', tags: 'Tags',
    createArticle: 'Create Article', editArticle: 'Edit Article',
    title: 'Title', content: 'Content', category: 'Category', status: 'Status',
    published: 'Published', draft: 'Draft', archived: 'Archived',
    save: 'Save', publish: 'Publish', delete: 'Delete', cancel: 'Cancel',
    views: 'Views', readingTime: 'min read', featured: 'Featured',
    darkMode: 'Dark Mode', language: 'Language',
    noResults: 'No results found', loading: 'Loading...',
    newsletterTitle: 'Stay Updated with Karnataka News',
    newsletterDesc: 'Get the latest news delivered to your inbox',
    footerDesc: 'Your trusted source for Karnataka news and updates',
    aboutUs: 'About Us', contactUs: 'Contact Us', privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service', followUs: 'Follow Us',
    allRightsReserved: 'All rights reserved',
    summarize: 'AI Summarize', translate: 'AI Translate',
    heritageCorner: 'Heritage Corner', techHub: 'Tech Hub Updates',
    newsAcrossKarnataka: 'News Across Karnataka', explore: 'Explore',
    innovation: 'Innovation', cultural: 'Cultural', opinionCorner: 'Opinion Corner',
    moreStories: 'More Stories', todaysDigest: "Today's Digest", readStory: 'Read Story',
  },
  kn: {
    home: 'ಮುಖಪುಟ', latest: 'ಇತ್ತೀಚಿನ', trending: 'ಟ್ರೆಂಡಿಂಗ್', categories: 'ವಿಭಾಗಗಳು',
    politics: 'ರಾಜಕೀಯ', business: 'ವ್ಯಾಪಾರ', sports: 'ಕ್ರೀಡೆ', entertainment: 'ಮನರಂಜನೆ',
    technology: 'ತಂತ್ರಜ್ಞಾನ', culture: 'ಸಂಸ್ಕೃತಿ', localNews: 'ಸ್ಥಳೀಯ ಸುದ್ದಿ',
    breakingNews: 'ಬ್ರೇಕಿಂಗ್ ನ್ಯೂಸ್', readMore: 'ಮತ್ತಷ್ಟು ಓದಿ', relatedArticles: 'ಸಂಬಂಧಿತ ಲೇಖನಗಳು',
    share: 'ಹಂಚಿಕೊಳ್ಳಿ', comments: 'ಅಭಿಪ್ರಾಯಗಳು', writeComment: 'ಅಭಿಪ್ರಾಯ ಬರೆಯಿರಿ...',
    postComment: 'ಅಭಿಪ್ರಾಯ ಹಾಕಿ', subscribe: 'ಚಂದಾದಾರರಾಗಿ', newsletter: 'ವಾರ್ತಾಪತ್ರ',
    subscribePlaceholder: 'ನಿಮ್ಮ ಇಮೇಲ್ ನಮೂದಿಸಿ', subscribeBtn: 'ಈಗ ಚಂದಾದಾರರಾಗಿ',
    search: 'ಹುಡುಕಿ', searchPlaceholder: 'ಸುದ್ದಿ ಹುಡುಕಿ...',
    login: 'ಲಾಗಿನ್', logout: 'ಲಾಗ್ ಔಟ್', admin: 'ನಿರ್ವಾಹಕ ಫಲಕ', editor: 'ಸಂಪಾದಕ ಫಲಕ',
    dashboard: 'ಡ್ಯಾಶ್‌ಬೋರ್ಡ್', articles: 'ಲೇಖನಗಳು', users: 'ಬಳಕೆದಾರರು', tags: 'ಟ್ಯಾಗ್‌ಗಳು',
    createArticle: 'ಲೇಖನ ರಚಿಸಿ', editArticle: 'ಲೇಖನ ಸಂಪಾದಿಸಿ',
    title: 'ಶೀರ್ಷಿಕೆ', content: 'ವಿಷಯ', category: 'ವಿಭಾಗ', status: 'ಸ್ಥಿತಿ',
    published: 'ಪ್ರಕಟಿಸಲಾಗಿದೆ', draft: 'ಕರಡು', archived: 'ಆರ್ಕೈವ್',
    save: 'ಉಳಿಸಿ', publish: 'ಪ್ರಕಟಿಸಿ', delete: 'ಅಳಿಸಿ', cancel: 'ರದ್ದುಮಾಡಿ',
    views: 'ವೀಕ್ಷಣೆಗಳು', readingTime: 'ನಿಮಿಷ ಓದುವ ಸಮಯ', featured: 'ವೈಶಿಷ್ಟ್ಯ',
    darkMode: 'ಡಾರ್ಕ್ ಮೋಡ್', language: 'ಭಾಷೆ',
    noResults: 'ಯಾವುದೇ ಫಲಿತಾಂಶ ಕಂಡುಬಂದಿಲ್ಲ', loading: 'ಲೋಡ್ ಆಗುತ್ತಿದೆ...',
    newsletterTitle: 'ಕರ್ನಾಟಕ ಸುದ್ದಿಗಳೊಂದಿಗೆ ನವೀಕೃತವಾಗಿರಿ',
    newsletterDesc: 'ಇತ್ತೀಚಿನ ಸುದ್ದಿಗಳನ್ನು ನಿಮ್ಮ ಇನ್‌ಬಾಕ್ಸ್‌ಗೆ ಪಡೆಯಿರಿ',
    footerDesc: 'ಕರ್ನಾಟಕ ಸುದ್ದಿ ಮತ್ತು ನವೀಕರಣಗಳಿಗೆ ನಿಮ್ಮ ವಿಶ್ವಾಸಾರ್ಹ ಮೂಲ',
    aboutUs: 'ನಮ್ಮ ಬಗ್ಗೆ', contactUs: 'ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ', privacyPolicy: 'ಗೌಪ್ಯತಾ ನೀತಿ',
    termsOfService: 'ಸೇವಾ ನಿಯಮಗಳು', followUs: 'ನಮ್ಮನ್ನು ಅನುಸರಿಸಿ',
    allRightsReserved: 'ಎಲ್ಲಾ ಹಕ್ಕುಗಳನ್ನು ಕಾಯ್ದಿರಿಸಲಾಗಿದೆ',
    summarize: 'AI ಸಾರಾಂಶ', translate: 'AI ಅನುವಾದ',
    heritageCorner: 'ಪರಂಪರೆ ಮೂಲೆ', techHub: 'ಟೆಕ್ ಹಬ್ ನವೀಕರಣಗಳು',
    newsAcrossKarnataka: 'ಕರ್ನಾಟಕದಾದ್ಯಂತ ಸುದ್ದಿ', explore: 'ಅನ್ವೇಷಿಸಿ',
    innovation: 'ನಾವೀನ್ಯತೆ', cultural: 'ಸಾಂಸ್ಕೃತಿಕ', opinionCorner: 'ಅಭಿಪ್ರಾಯ ಮೂಲೆ',
    moreStories: 'ಹೆಚ್ಚಿನ ಕಥೆಗಳು', todaysDigest: 'ಇಂದಿನ ಡೈಜೆಸ್ಟ್', readStory: 'ಕಥೆ ಓದಿ',
  }
};

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem('taaynadu-lang') || 'kn');

  useEffect(() => { localStorage.setItem('taaynadu-lang', lang); }, [lang]);

  const t = (key) => translations[lang]?.[key] || translations.en[key] || key;
  const toggleLang = () => setLang(prev => prev === 'en' ? 'kn' : 'en');
  const isKannada = lang === 'kn';

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, toggleLang, isKannada }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
